import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
@Component({
	selector: 'app-decription-header',
	templateUrl: './decription-header.component.html',
	styleUrls: ['./decription-header.component.css'],
})
export class DecriptionHeaderComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/description_header/';
	protected parentComponent = 'codebook/decription_header';
	codebook;

	protected pageTitleGenerate(): string {
		return `Słowniki ->
			${this.codebook.name}
			->
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		name: null,
		header: null,
		multimedia: { id: '', name: '', url: '' },
		comment: null,
	};
	editor = ClassicEditor;
	editorConfig = {
		placeholder: 'Treść "dymka", podpowiedź podczas wprowadzania opisów',
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};

	protected convertData(data: any) {
		if (data.multimedia === null) {
			data.multimedia = {
				id: '',
				name: '',
				url: '',
			};
		}

		return data;
	}
	protected loadBefore(): void {
		this.bag.get('/codebook/3/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected getApiUrl(): string {
		return '/description_header/' + this.data.id + '/';
	}

	protected submitConvert(data: any) {
		return {
			id: data.id,
			name: data.name,
			header: data.header,
			multimedia: data.multimedia.id,
			comment: data.comment,
		};
	}

	onFileSelected(event): void {
		this.bag.upload('/multimedia/file/', event.target.files[0], (result, error) => {
			this.data.multimedia = result;
		});
	}

	deleteImage() {
		this.data.multimedia = { id: '', url: '', name: '' };
	}
}
